module.exports = __webpack_public_path__ + "img/criterionimg5.9ecc77b3.png";